export const ru = {
    cancel: 'Отменить',
    'set-smart-center': 'Установить смарт-центр',
    'smart-center-title': 'Смарт-центр'
};
